 <template>
   <div id="app">
     <MainComponent
        v-model="code"
        ></MainComponent>
   </div>
 </template>

 <script>
 import MainComponent from "./components/MainComponent.vue";

 export default {
   name: "app",
   components: {
     MainComponent
   },
   data: () => ({
     lineNumbers: true,
     readonly: false,
     code: `Érase una vez...`
   })
 };
 </script>

 <style>
 .my-editor {
   max-height: 378px;
 }
 </style>
